var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('loading') : _vm._e(), _vm.showSuccess ? _c('div', {
    staticClass: "container mt-5"
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.avatarUrl,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('div', {
    staticClass: "text-center font-weight-bolder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.lineData.displayName))])])]), _vm._m(0), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mb-1 mt-3",
    attrs: {
      "variant": "success",
      "size": "lg"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" " + _vm._s(_vm.redirectText) + " ")])], 1)], 1)]) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('h5', [_vm._v("帳號綁定成功")])]);
}]

export { render, staticRenderFns }